import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { ui } from '../../../../../../../../../interfaces/interfaces';
import Grid from '@mui/material/Grid2';
import PropertyCard from './PropertyCard';
import CustomerCard from './CustomerCard';
import AccountCard from './AccountCard';
import BookingCard from './BookingCard';
import EngineerCard from './EngineerCard';
import JobNotesCard from './JobNotesCard';
import { getCompletionDetails, getJobDetails } from './helpers';
import { DialogTitle } from '@mui/material';
import { useAppSelector } from "@store/hooks";
import { RightioWBSAPIModelsSPSpJobsCompletionsGetCompletionsResult, RightioWBSAPIModelsSPSpJobsGetJobDetailsResult } from '../../../../../../../../../utilities/apis/wbs/endpoints';

const name = "LastJobModal";

interface LastJobModalProps {
    parent: string
}

const handleClose = () => {
    ui.LastJobModal = false;
};

const LastJobModal: React.FC<LastJobModalProps> = ({ parent }) => {
    const open = useAppSelector(({ ui }) => ui.LastJobModal)
    const lastJob = useAppSelector(({ state }) => state.LastJob)
    const [job] = React.useState(lastJob[0])
    const [jobDetails, setJobDetails] = React.useState<RightioWBSAPIModelsSPSpJobsGetJobDetailsResult>()
    const [jobCompletion, setJobCompletion] = React.useState<RightioWBSAPIModelsSPSpJobsCompletionsGetCompletionsResult>()

    React.useEffect(() => {
        if (job.jobId) {
            getJobDetails(job.jobId).then(setJobDetails)
            getCompletionDetails(job.jobId).then(setJobCompletion)
        }
    }, [job.jobId])

    return (
        (<Dialog
            maxWidth="lg"
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: "#e7e7e7",
                },
            }}
            BackdropProps={{
                sx: {
                    backgroundColor: "#b9b9b9",
                },
            }}
        >
            <DialogTitle sx={{ backgroundColor: "#fff" }}>
                Job History {jobDetails && jobDetails.jobId}
            </DialogTitle>
            <DialogContent dividers>
                {/* <DialogContentText>
                    Let Google help apps determine location. This means sending anonymous
                    location data to Google, even when no apps are running.
                </DialogContentText> */}
                <Grid container spacing={1}>
                    <Grid size={4}>
                        <AccountCard job={job} parent='LastJobModal' jobDetails={jobDetails} />
                        <EngineerCard job={job} parent='LastJobModal' jobDetails={jobDetails} />
                    </Grid>
                    <Grid size={4}>
                        <BookingCard job={job} parent='LastJobModal' jobDetails={jobDetails} />
                        <JobNotesCard job={job} parent='LastJobModal' jobDetails={jobDetails} jobCompletion={jobCompletion} />
                    </Grid>
                    <Grid size={4}>
                        {/* // card presenting address, each property should be align to right and value aligned to left */}
                        <PropertyCard parent='LastJobModal' job={job} jobDetails={jobDetails} />
                        <CustomerCard parent='LastJobModal' job={job} jobDetails={jobDetails} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: "#fff" }}>
                <Button variant='contained' onClick={handleClose} autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog >)
    );
}

LastJobModal.displayName = name;

export default React.memo(LastJobModal)